import { render, staticRenderFns } from "./shaparak-requests.vue?vue&type=template&id=3de5ff28"
import script from "./shaparak-requests.vue?vue&type=script&lang=js"
export * from "./shaparak-requests.vue?vue&type=script&lang=js"
import style0 from "./shaparak-requests.vue?vue&type=style&index=0&id=3de5ff28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports